import { render, staticRenderFns } from "./SidebarCollaborators.vue?vue&type=template&id=da507a92&scoped=true&"
import script from "./SidebarCollaborators.vue?vue&type=script&lang=js&"
export * from "./SidebarCollaborators.vue?vue&type=script&lang=js&"
import style0 from "./SidebarCollaborators.vue?vue&type=style&index=0&id=da507a92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da507a92",
  null
  
)

export default component.exports